import { useState, useCallback, useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import {
  deleteOfficeSettings,
  exportOfficeSettings,
} from "../../../actions/CarrierAgreementMgmt/OfficeSettings";
import { toast } from "../../../components/toastNotification";
import { useSFGetOffice } from "./hooks/useSFGetOffice";
import useSearchOfficeSettings from "./hooks/useSearchOfficeSettings";
import useSearchOfficeByOfficeHierarchyId from "./hooks/useSearchOfficeByOfficeHierarchyId";
import { officeSearchData, officesOptions, getOffices } from "./atoms/atoms";
import { useRecoilState } from "recoil";
import OfficeSettingsMain from "./OfficeSettingsMain";
import { notificationFilterById } from "../../../actions/Utilities/NotificationFilter";
import { OfficeListFromLink } from "../Employees/Confie/atoms/atoms";

const OfficeSetting = () => {
  const {
    data: offices,
    isSuccess: getOfficeSuccess,
    isLoading: officeLoading,
  } = useSFGetOffice();

  const [officeData, setOfficeData] = useRecoilState(getOffices);
  const [officeDistrictCodes, setOfficeDistrictCodes] = useState();
  const [, setOfficeOptions] = useRecoilState(officesOptions);
  const [toggledRows, setToggledRows] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [, setIsBulkSelected] = useState(false);
  const [notifFilter, setNotifFIlter] = useState(false);
  let recordIdFromRecent = "";
  let location = useLocation();
  const history = useHistory();
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (offices?.length > 0) {
      setOfficeDistrictCodes(offices?.filter((x) => x.districtCode !== null));
    }
  }, [offices]);

  useEffect(() => {
    if (getOfficeSuccess && offices && !notifFilter) {
      if (offices.statusCode) {
        toast.fire("Server Error", "Cannot Get Office Data", "error");
        setOfficeData({
          data: [],
          isLoading: officeLoading,
          isSuccess: getOfficeSuccess,
        });
      } else {
        // setOfficeData(offices.map((data) => ({ ...data }))); //Fix for : Cannot add property tableData, object is not extensible

        setOfficeData({
          data: offices.map((data) => ({ ...data })),
          isLoading: officeLoading,
          isSuccess: getOfficeSuccess,
        });

        setOfficeOptions(
          offices.map((resData) => {
            return {
              label: resData.officeName,
              value: resData.officeCode,
              id: resData.officeId,
            };
          })
        );
      }
    }
  }, [getOfficeSuccess, offices, notifFilter]);

  const [resetStatus, setresetStatus] = useState(false);

  const {
    mutate: searchOfficeByHierarchyId,
    data: searchByHierarchyIdResult,
    isSuccess: searchByHierarchyIdSuccess,
    isLoading: searchByHierarchyIdLoading,
  } = useSearchOfficeByOfficeHierarchyId();

  const [searchInputsData, setSearchInputsData] =
    useRecoilState(officeSearchData);
  const [searchId, setSearchId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchByHierachyId, setSearchByHierachyId] = useState("");
  const [filteredOfficeData, setFilteredOfficeData] = useState([]);
  const [filterStatus, setFilterStatus] = useState(false);
  const [enableSearch, setEnableSearch] = useState(false);
  const [officeCodeList] = useRecoilState(OfficeListFromLink);

  //Office Search Function
  const {
    isSuccess: searchSuccess,
    data: searchResult,
    isFetching: searchLoading,
    refetch: searchRefetch,
  } = useSearchOfficeSettings({
    searchInputsData,
    enableSearch,
  });

  const search = location.search;
  const qs = new URLSearchParams(search);
  const qsId = qs.get("id");
  const qsName = qs.get("name");
  const qsHierarchyId = qs.get("hierarchyId");

  //FOR SEARCHING USING ID FROM EMAIL LINK
  if (qsId && searchId === "" && !searchSuccess) {
    setSearchId(qsId);
    setSearchInputsData({ OfficeId: qsId });
    setFilterStatus(true);
  }

  //search By Office Hierachy Id
  if (
    qsHierarchyId &&
    searchByHierachyId === "" &&
    !searchByHierarchyIdSuccess
  ) {
    setSearchByHierachyId(qsHierarchyId);
  }
  if (
    !searchByHierarchyIdLoading &
    !searchByHierarchyIdResult &
    (searchByHierachyId !== "")
  ) {
    searchOfficeByHierarchyId(searchByHierachyId);
    setSearchByHierachyId("");
  }

  if (searchByHierarchyIdSuccess && searchByHierachyId !== "") {
    setFilteredOfficeData(searchByHierarchyIdResult);
    setFilterStatus(true);
    setSearchByHierachyId("");
  }

  if (searchSuccess && searchName !== "") {
    setSearchInputsData((searchInputsData) => ({
      ...searchInputsData,
      OfficeName: searchName,
    }));

    setFilteredOfficeData(searchResult);
    setFilterStatus(true);
    setSearchName("");
  }
  const [officeId, setOfficeId] = useState("");
  //fitler for carrier view settings
  useEffect(() => {
    let actionFrom = new URLSearchParams(window.location.search).get(
      "actionFrom"
    );
    if (recordIdFromRecent && recordIdFromRecent.moduleName === "Office") {
      if (recordIdFromRecent.action === "viewSettings") {
        setSearchInputsData({
          ...searchInputsData,
          Carriers: [recordIdFromRecent.recordId],
          SelectedCarrier: recordIdFromRecent.recordId,
        });
        setFilterStatus(true);
        setEnableSearch(true);
      } else {
        //FROM RECENT ACTIVITY
        if (offices) {
          setNotifFIlter(true);
          setFilterStatus(true);

          setFilteredOfficeData(offices);
          setOfficeId(recordIdFromRecent.recordId);
          history.replace();
        }
      }
    } else if (
      recordIdFromRecent.action === "employeeMultipleOffice" &&
      offices?.length > 0
    ) {
      history.replace();
      const officeCodes = recordIdFromRecent?.officeCodes.split(",");
      setFilteredOfficeData(
        offices?.filter((x) => officeCodes?.includes(x.officeCode))
      );
      setFilterStatus(true);
      setSearchInputsData((prev) => {
        return {
          ...prev,
          OfficeCodeId: officeCodes,
          OfficeCode: officeCodes.map((office) => {
            return { value: office };
          }),
        };
      });
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [offices]);

  useEffect(() => {
    if (recordIdFromRecent.action !== "employeeMultipleOffice") {
      if (officeId.includes(".")) {
        // For multiple filter
        let officeIds = officeId.split(".");
        const officeIdArr = officeIds.map((num) => Number(num));
        const filteredOffices = offices?.filter((x) =>
          officeIdArr.includes(x.officeId)
        );
        setFilteredOfficeData(filteredOffices);
      } else {
        // For single filter
        const filteredOffices = offices?.filter(
          (x) => x.officeId === Number(officeId)
        );
        setFilteredOfficeData(filteredOffices);
      }
    }
  }, [officeId, offices]);

  useEffect(() => {
    //FOR SEARCHING FROM EMAIL LINKS
    if (searchId || searchName) {
      searchRefetch();
    }
  }, [searchId, searchName]);

  var newOffice = {
    AgencyId: 0,
    OfficeCode: "",
    StoreNumber: "",
    OfficeName: "",
    GeneralLedgerNumber: 0,
    AgencyName: "",
    EntityEid: "",
    LineOfBusiness: "",
    Address: "",
    City: "",
    State: "",
    StateCode: "",
    ZipCode: "",
    TargetSystemId: 0,
    DateOpen: null,
    DateClosed: null,
    OfficeStatusId: 0,
    CreatedBy: "",
    ModifiedBy: "",
    IsActive: "",
    MultipleState: [],
    CarrierProducerCodeId: [],
  };
  const [newOfficeData, setNewOfficeData] = useState(newOffice);

  const queryClient = useQueryClient();
  const emptyRowItems = {
    RowId: 1,
    Carrier: [],
    States: "",
    ProducerCode: [],
    LOB: "",
  };

  //if search is success
  if (searchSuccess && !notifFilter) {
    if (filteredOfficeData !== searchResult) {
      history.replace();
      if (searchResult && !searchResult.statusCode) {
        setFilteredOfficeData(searchResult);
      } else {
        setFilteredOfficeData([]);
      }
    }
  }

  const deleteOfficeSettingsMutation = useMutation(
    (officeIds) =>
      deleteOfficeSettings(officeIds, localStorage.getItem("userName")),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("OfficeSettings");
        toast.fire(
          "Success",
          "Office Settings were deleted Successfully.",
          "success"
        );

        setSelectedRows([]);
        setToggledRows(!toggledRows);
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          queryClient.invalidateQueries("OfficeSettings");
          toast.fire(
            "Warning",
            "Deleted Successfully, but " + error.response.data.message,
            "warning"
          );
          setSelectedRows([]);
          setToggledRows(!toggledRows);
        } else {
          toast.fire(
            "Bulk deleting of Office Settings failed",
            "Server Error: Cannot delete office settings.",
            "error"
          );
        }
      },
    }
  );

  const handleSelectedRowsChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    setIsBulkSelected((prev) => !prev);
  }, []);

  const filterOfficeSettings = () => {
    localStorage.removeItem("NotifFilter");
    localStorage.removeItem("ModuleFilter");

    setFilterStatus(true);
    searchRefetch();
  };

  //Function for Download Button - OLD
  const handleExportButton = () => {
    try {
      let dateTimeToday = new Date(new Date().toISOString()).toISOString();
      const ids = filterStatus
        ? filteredOfficeData.map((row) => row.officeId)
        : officeData.data.map((row) => row.officeId);
      exportOfficeSettings(ids).then((content) => {
        var url = window.URL.createObjectURL(content.data);
        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute(
          "download",
          "OfficeReport_" + dateTimeToday + ".xlsx"
        );
        tempLink.click();
        toast.fire(
          "Success",
          "Office Report were exported successfully.",
          "success"
        );
      });
    } catch (error) {
      toast.fire(
        "Failed to Export",
        "Server Error: Cannot export office data due to: " + error,
        "error"
      );
    }
  };

  const bulkDeleteMessage = (
    <div className="text-Colortext font-semibold">{`Are you sure you want to delete ${selectedRows?.length} Office?`}</div>
  );
  const singleDeleteMessage = (
    <div className="text-Colortext font-semibold">{`Are you sure you want to delete 1 Office ?`}</div>
  );
  return (
    <div>
      <OfficeSettingsMain
        data={filterStatus ? filteredOfficeData : officeData.data}
        filterOfficeSettings={filterOfficeSettings}
        setFilterStatus={setFilterStatus}
        setFilteredOfficeData={setFilteredOfficeData}
        setresetStatus={setresetStatus}
        loading={officeLoading || searchLoading}
        searchRefetch={searchRefetch}
        officeDistrictCodes={officeDistrictCodes}
        officeIsLoading={officeLoading}
      />
    </div>
  );
};

export default OfficeSetting;
